<template>
  <div class="box">
    <div class="info">
      <InputBox text="測試者全名" placeholder="請輸入測試者全名" margin_top="short" :value="user_info.name" @getValue="getNameValue">
      </InputBox>
    </div>
    <div class="info">
      <InputBox text="電話號碼" hideInput="true" margin_top="short" :value="user_info.show_mobile"></InputBox>
    </div>
    <div v-if="is_join == 1 && !is_staff">
      <div class="info">
        <!-- <SelectBox text="跟進機構" :options="organization_option" margin_top="short" @getValue="getOrganizationValue"></SelectBox> -->
        <InputBox text="跟進機構" hideInput="true" margin_top="short" :value="user_info.ngo_name"></InputBox>
      </div>
    </div>
    <div v-if="is_join == 0">
      <div class="info">
        <InputBox text="參加意願" hideInput="true" margin_top="short" value="不參加"></InputBox>
      </div>
      <div class="info">
        <SelectBox text="不參加計劃的原因" :options="reason_option" margin_top="short" @getValue="getReasonValue"></SelectBox>
      </div>
      <div class="info" v-if="reason == 4">
        <InputBox text="其他原因" placeholder="請輸入" margin_top="short" @getValue="getOtherReasonValue"></InputBox>
      </div>

    </div>

  </div>
</template>

<script>
import common from "../../common";
import InputBox from "../common/InputBox";
import SelectBox from "../common/SelectBox";

export default {
  name: "FollowUpInfo",
  components: { SelectBox, InputBox },
  props: {
    user_info: { type: Object },
    is_join: { type: String },
    is_staff: { type: Boolean, default: false },

  },
  data() {
    return {
      name: '',
      organization_id: 0,
      reason: 0,
      other_reason: '',
      organization_option: [
        { id: 0, text: '請選擇' },
        { id: 1, text: '耆智園(新界東及其他地區)' },
        { id: 2, text: '信義會(新界西)' },
        { id: 3, text: '樂善堂(九龍中)' },
        { id: 4, text: '靈實協會(西貢及將軍澳)' },
      ],
      reason_option: [
        { id: 0, text: '請選擇' },
        { id: 1, text: '已有醫生跟進' },
        { id: 2, text: '機構地點不方便' },
        { id: 3, text: '自己覺得無需跟進' },
        { id: 4, text: '其他原因' },
      ]
    }
  },
  methods: {
    getNameValue: function (value) {
      this.name = value
    },
    getOrganizationValue: function (value) {
      this.organization_id = value;
    },
    getReasonValue: function (value) {
      this.reason = value;
    },
    getOtherReasonValue: function (value) {
      this.other_reason = value;
    },
    getJoinInfo: function (organization_id) {
      if (!this.name) {
        common.showAlert('請輸入測試者全名。');
        return false;
      }
      // if (!this.organization_id && !organization_id) {
      //   common.showAlert('請選擇跟進機構');
      //   return false;
      // }
      if (organization_id) {
        this.organization_id = organization_id;
      }

      this.$emit('getJoinInfo', { name: this.name, organization_id: this.organization_id })
      return true;
    },
    getNoJoinInfo: function () {
      if (!this.name) {
        common.showAlert('請輸入測試者全名。');
        return false;
      }
      if (!this.reason) {
        common.showAlert('請選擇不參加計劃的原因');
        return false;
      }
      if (this.reason == 4 && !this.other_reason) {
        common.showAlert('請輸入其他原因');
        return false;
      }

      this.$emit('getNoJoinInfo', { name: this.name, reason: this.reason, other_reason: this.other_reason })
      return true;
    }
  }
}
</script>

<style scoped>
.box {
  text-align: center;
  font-size: var(--ecs-font-md);
}

.info {
  margin: clamp(0.25rem, 0.8vw, 0.5rem) auto;
  //min-height: var(--ecs-option-min-height);
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.info :deep(.box) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.5rem, 1.5vw, 1rem);
  text-align: left;
}

.info :deep(.text) {
  flex: 0 0 clamp(7rem, 16vw, 10rem);
  width: auto;
  margin: 0;
  text-align: right;
}

.info :deep(.input),
.info :deep(.select) {
  flex: 0 1 clamp(12rem, 28vw, 20rem);
  width: auto;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--ecs-form-control-min-height);
  padding-top: var(--ecs-form-control-padding-y);
  padding-bottom: var(--ecs-form-control-padding-y);
}

.text {
  float: left;
}

.name {
  width: var(--ecs-control-width-sm);
}

.organization {
  width: var(--ecs-control-width-sm);
}

.align_left {
  text-align: left;
  float: left;
}</style>
